import { LoveEatPage } from "./pages/love-eat"

export const loveEat = {
  themeOptionFactories: null,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "love-eat",
        element: <LoveEatPage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
